"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var UserSettingsForm_module_css_1 = __importDefault(require("./UserSettingsForm.module.css"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var TwoFactorAuthentication = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("form", { id: UserSettingsForm_module_css_1.default.contentContainer },
        react_1.default.createElement("div", { id: UserSettingsForm_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.title },
                react_1.default.createElement("span", null, t("Coming Soon"))),
            react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.inputContainer },
                react_1.default.createElement(Label_1.default, { htmlFor: "comingSoon", className: UserSettingsForm_module_css_1.default.label }, t(""))))));
};
exports.default = TwoFactorAuthentication;
